import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { ISetRegisterInfoPayload } from '../../interfaces/redux.interface'
import { RootState } from '../store'

// Define a type for the slice state
interface AuthState {
    accessToken?: string | null
    refreshToken?: string | null
    phoneNumber?: string | null
    nationalCode?: string | null
}

// Define the initial state using that type
const initialState: AuthState = {
    accessToken: localStorage.getItem('dc_accessToken'),
    refreshToken: localStorage.getItem('dc_refreshToken'),

    phoneNumber: localStorage.getItem('dc_phoneNumber'),
    nationalCode: localStorage.getItem('dc_nationalCode'),
}

export const authSlice = createSlice({
    name: 'authorization',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        setAccessToken: (state, action: PayloadAction<string>) => {
            localStorage.setItem('dc_accessToken', action.payload)
            state.accessToken = action.payload
        },
        setRefreshToken: (state, action: PayloadAction<string>) => {
            localStorage.setItem('dc_refreshToken', action.payload)
        },
        setRegisterInfo: (
            state,
            action: PayloadAction<ISetRegisterInfoPayload>
        ) => {
            localStorage.setItem('dc_phoneNumber', action.payload.phoneNumber)
            localStorage.setItem('dc_nationalCode', action.payload.nationalCode)
            state.nationalCode = action.payload.nationalCode
            state.phoneNumber = action.payload.phoneNumber
        },
        logout: (state) => {
            localStorage.removeItem('dc_phoneNumber')
            localStorage.removeItem('dc_nationalCode')
            localStorage.removeItem('dc_refreshToken')
            localStorage.removeItem('dc_accessToken')

            state.nationalCode = null
            state.phoneNumber = null
            state.accessToken = null
            state.refreshToken = null
        },
    },
})

export const { setAccessToken, setRegisterInfo, logout, setRefreshToken } =
    authSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectRegisterInfo = (state: RootState) => ({
    phoneNumber: state.authorization.phoneNumber,
    nationalCode: state.authorization.nationalCode,
})

export const selectRefreshToken = (state: RootState) =>
    state.authorization.refreshToken

export const selectAccessToken = (state: RootState) =>
    state.authorization.accessToken
export default authSlice.reducer
